import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useBazi } from '../contexts/BaziContext';

export default function BaziBar() {
  const { baziData, isBaziLoaded, getPillarSummary, getUsefulGod, clearBaziData } = useBazi();
  const navigate = useNavigate();
  const location = useLocation();
  const [showConfirm, setShowConfirm] = useState(false);

  // 首页首屏不显示
  const isHome = location.pathname === '/';
  const isZhiPage = location.pathname === '/zhi';
  if (!isBaziLoaded || isHome) return null;

  const pillarSummary = getPillarSummary();
  const usefulGod = getUsefulGod();
  const pattern = baziData?.pattern || '—';
  const dayMaster = baziData?.day_master || '—';

  const handleChangeBazi = () => {
    setShowConfirm(true);
  };

  const handleConfirmChange = () => {
    clearBaziData();
    setShowConfirm(false);
    navigate('/');
  };

  return (
    <>
      {/* 底部常驻命盘栏 */}
      <div className="fixed bottom-0 left-0 right-0 z-40 bg-[#FFF8EB] border-t border-amber-200/60 shadow-[0_-2px_12px_rgba(0,0,0,0.04)]"
        style={{ height: '48px', paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
        <div className="max-w-4xl mx-auto h-full px-4 flex items-center justify-between text-xs">
          {/* 左侧命盘信息 */}
          <div className="flex items-center gap-3 min-w-0 flex-1">
            <span className="text-stone/50 shrink-0">📋</span>
            <span className="font-medium text-ink truncate">
              当前命盘：
            </span>
            <span className="text-zhusha font-semibold font-serif whitespace-nowrap">
              {pillarSummary || `${dayMaster}日主`}
            </span>
            <span className="text-stone/30 hidden sm:inline">|</span>
            <span className="text-stone/60 hidden sm:inline whitespace-nowrap">
              {pattern}
            </span>
            <span className="text-stone/30 hidden sm:inline">|</span>
            <span className="text-stone/60 hidden sm:inline whitespace-nowrap">
              用神：{usefulGod}
            </span>
          </div>

          {/* 右侧按钮组 */}
          <div className="shrink-0 flex items-center gap-1">
            {!isZhiPage && (
              <Link
                to="/zhi"
                className="text-xs text-amber-600 hover:text-amber-700 transition-colors px-2 py-1 rounded-md hover:bg-amber-50 font-medium"
              >
                🦊 知知
              </Link>
            )}
            <button
              onClick={handleChangeBazi}
              className="text-xs text-stone/50 hover:text-zhusha transition-colors px-2 py-1 rounded-md hover:bg-zhusha/5"
            >
              [更换命盘]
            </button>
          </div>
        </div>
      </div>

      {/* 确认弹窗 */}
      {showConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm px-4">
          <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl">
            <h3 className="text-lg font-bold text-ink mb-2">更换命盘</h3>
            <p className="text-sm text-stone/70 mb-6 leading-relaxed">
              更换命盘将清除当前分析进度，确定吗？
            </p>
            <div className="flex gap-3">
              <button
                onClick={() => setShowConfirm(false)}
                className="flex-1 py-2.5 border border-stone/30 text-stone rounded-xl text-sm font-medium hover:bg-gray-50 transition-colors"
              >
                取消
              </button>
              <button
                onClick={handleConfirmChange}
                className="flex-1 py-2.5 bg-zhusha text-white rounded-xl text-sm font-medium hover:bg-red-800 transition-colors"
              >
                确定更换
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
